const zh_CN = {
  placeholderText: "请输入",
  closeContentText: "确定结束当前对话?",
  cancelText: "取消",
  okText: "确定",
  loadingAnswerQuestions: "正在回答上一个问题，请稍后提交",
  networkAnomalyText: "网络异常，请稍后重试",
  errorText: "服务器错误",
  messageTooShort: "至少需要输入2个文字",
  messageTooLong: "不能超过200个文字",
  messageCannotBeEmpty: "问题不能为空",
  systemErrorText: "系统错误，请稍后重试",
  fileSizeExceeded: "单个文件不能超过{maxSize}MB",
  fileUploadSuccess: "文件上传成功",
  fileUploadFailed: "文件上传失败",
  emailErrorText: "邮箱格式错误",
  emailEmptyText: "请填写邮箱",
  uploadingText: "正在上传中...",
  abnormalDisconnectionText: "异常断开，正在为您重连...",
  reconnectToServerText: "无法重新连接到服务器",
  evaluationText: "您的评价让我们做的更好！",
  emailLabel: "邮箱",
  emailPlaceholder: "请输入邮箱",
  productLabel: "产品",
  productPlaceholder: "请选择产品",
  problemLabel: "问题描述",
  problemPlaceholder: "请输入问题描述",
  submitText: "提交",
  submitField: "抱歉，未提交成功，请稍后重试",
  thankText:
    "感谢您的配合，我们会尽快联系您！请关注邮箱或者{link}留意消息回复！",
  clickHere: "点击此处",
  thankEvaluation: "感谢您的评价！",
  wsErrorText: "无法接通人工客服",
  codeLabel: "验证码",
  codePlaceholder: "请输入验证码",
  submittedSuccessfully: "提交成功",
  supportContact: "客户支持",
  stillCancel: "坚持取消",
  useDiscount: "使用折扣",
  pauseDuration: "暂停时长",
  uploadAttachment: "上传附件",
};
export default zh_CN;
